import store from "../../../store/store";
import constants from "../../../utils/constants";
import axios from "../../axios";
// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
	subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
	subscribers.push(callback);
}

export default {
	getList(payload) {
		return axios.post(constants.API.TRACKING.LIST, payload || null);
	},
	getDetail(id, payload = null) {
		return axios.get(`${constants.API.TRACKING.DETAIL}${id}`, payload);
	}
};
